/* eslint-disable quotes */
import { h } from 'vue';

const body = `<h4>Suggest a feature!</h4>

<p>Are we missing some feature or improvement that would make your work easier? Please help us out by clicking here and sugggesting it!</p>`;

export default function LightbulbTooltip() {
    return h('div', { innerHTML: body });
}
